export default __webpack_public_path__ + "static/media/resolucao-2018.25de1c4a.pdf";